import { takeLatest, put } from "redux-saga/effects";
import { FETCH_MontantInvest_REQUEST, REDIRECT_TO_LOGIN } from "./actionsTypes";
import {
  fetchMontantInvestSuccess,
  FETCH_MontantInvest_FAILURE,
  redirectToLogin,
} from "./actions";
import axios from "axios";
import Config from "config";
function* fetchMontantInvestData(action) {
  // const { token} = action.payload;
  const api = Config.backOffice.apiName;

  const token = localStorage.getItem("auth_token_" + api);
  try {
    const response = yield axios.get(
      `https://www.fluxod.com/${api}/fdashboards/widget_dash_montant_investissements`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    yield put(fetchMontantInvestSuccess(response.data));
  } catch (error) {
    yield put({ type: REDIRECT_TO_LOGIN });
  }
}

function* MontantInvestSaga() {
  yield takeLatest(FETCH_MontantInvest_REQUEST, fetchMontantInvestData);
}

export default MontantInvestSaga;
